import { render, staticRenderFns } from "./stuKnsCount.vue?vue&type=template&id=895e9128&scoped=true"
import script from "./stuKnsCount.vue?vue&type=script&lang=js"
export * from "./stuKnsCount.vue?vue&type=script&lang=js"
import style0 from "./stuKnsCount.vue?vue&type=style&index=0&id=895e9128&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "895e9128",
  null
  
)

export default component.exports